export default "__VITE_ASSET__DjS5$6Da__"